import { FormApiAssujetti } from 'form-api';
import { AxeConformiteAssujetti } from '../../conformite/common/controller/conformite.definition';
import { AssujettiToSet } from '../infrastructure/assujetti.definition';

export const assujettiControllerUrl = 'assujetti';
export const setAssujettiUrl = assujettiControllerUrl;

export const RoleAssujetti = FormApiAssujetti.RoleAssujetti;
export type RoleAssujetti = FormApiAssujetti.RoleAssujetti;

type WithTypedOptionalAxes<T> = Omit<T, 'optionalAxes'> & {
  optionalAxes: AxeConformiteAssujetti[] | null;
};

export type SetAssujettiResponseType =
  WithTypedOptionalAxes<FormApiAssujetti.AssujettiDto>;
export type SetAssujettiRequestType = AssujettiToSet;

export const listAssujettiUrl = assujettiControllerUrl;
export type ListAssujettiResponseType =
  WithTypedOptionalAxes<FormApiAssujetti.AssujettiDto>[];
export type ListAssujettiWithAvancementResponseType =
  WithTypedOptionalAxes<FormApiAssujetti.AssujettiWithAvancement>[];
export type ListAssujettiWithAvancementAndTotalResponseType = {
  assujettis: ListAssujettiWithAvancementResponseType;
  total: number;
};

export type Avancement = FormApiAssujetti.AvancementDto;
export type DeleteMultipleAssujettiRequestType = {
  ids: string[];
};
export type DeleteMultipleAssujettiResponseType = number;

export type AssujettiWithAvancement =
  WithTypedOptionalAxes<FormApiAssujetti.AssujettiWithAvancement>;
